<div class="bg">
    <div id="chartdiv"></div>

</div>